module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABZUlEQVRIS63VPUscURQG4EeiIRamsDONKU2VtKKmkQRiJwGxlhQSFSshf0EQREmXrzpE0mmjCInGXgutTWE6Cy0UP0i4cAzL6N2ZZXeahbn3PHOYfc+dNndfS3iLj/H7N7Mve7sts3KJ9libx7tWwZ8wUYPN4H0jeK7j+1jDcGDXGMP3qngOTvUP8RNPAzvDS2xXwevBqf4RdtAb2DEGcVCGl8Gp/kl02R3YIfrxpx5eBU71qct1PAhsF0M4zeFV4VT/Gl9xL7ANjCBF89bVCJyKU+yWa5QUyzetgJPxA88Du0JHK+CpwqB8KQzS/2c08ipG8a3mHW/iFS6a6XggUtEZyF6k4qSZVPThF25y/DtyfNRMjnti8h7XTF7K734zk9cVZ8WzQM7jrNgqQ9N67s9LEVrFi0DS6TaOlSpoPfhDIfizhcEo9XMdpwjdBH8Bc6VSYUMOXsQ0PmMSLfvmNdrgrf3/AA/DOBcTtuxAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/my/icon/logo/go.png
// module id = F+3H
// module chunks = 0